export default __webpack_public_path__ + "static/media/solucao-02.0e7cf847.webp";